import { Input } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-help',
    template: `<span [ngbTooltip]="text" class="fi fi-rs-interrogation" [triggers]="'click'"></span>`,
    styles: ['span { cursor: pointer; display: inline-block; margin-left: 4px; }']
})
export class HelpComponent {
    @Input() text: string;
}
